angular.module('flipto.accountv1.SharedFeatures')
    .factory("Demotype", function () {
        function Demotype(name, id, script) {
            this.name = name;
            this.id = id;
            this.script = script;
        }

        return Demotype;
    });